
import React from 'react'
import { Box } from '@mui/material'
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import CardsStaps from './CardsStaps';
import { CardsStaps00, CardsStaps001, CardsStaps002, Cardslanloards00, Cardslanloards001, Cardslanloards002 } from '../assets/data';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && (
        <div>{children}</div>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Cards = () => {
  const [value, setValue] = React.useState(0);
  const [homeownerValue, setHomeownerValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleHomeownerChange = (event, newValue) => {
    setHomeownerValue(newValue);
  };

  return (
    <>
      <Box className="cards_stap" id="card_scroll">
        <Box className="steps_cards">
          <Box>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" className='staptabesection cards_tab'>
              <Tab label="£0.00" {...a11yProps(0)} className='btnTab' />
              <Tab label="£75.00" {...a11yProps(1)} />
              {/* <Tab label="£95.00" {...a11yProps(2)} /> */}
            </Tabs>
          </Box>

          <CustomTabPanel value={value} index={0}>
            <CardsStaps priceIndex={0} homeownerValue={homeownerValue} onHomeownerChange={handleHomeownerChange} data={CardsStaps00} landdata={Cardslanloards00} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <CardsStaps priceIndex={1} homeownerValue={homeownerValue} onHomeownerChange={handleHomeownerChange} data={CardsStaps001} landdata={Cardslanloards001} />
          </CustomTabPanel>
          {/* <CustomTabPanel value={value} index={2}>
            <CardsStaps priceIndex={2} homeownerValue={homeownerValue} onHomeownerChange={handleHomeownerChange} data={CardsStaps002} landdata={Cardslanloards002} />
          </CustomTabPanel> */}
        </Box>
      </Box>
    </>
  )
}

export default Cards;